import { Text } from '@domain-group/suit-theme'

interface LogoTextProps {
  attachment_type: string,
}

const LogoText = (props: LogoTextProps) => {
  const { attachment_type } = props

  return (
    <>
      { attachment_type === 'public_link_logo' && (
        <>
          <Text
            color="bodyFontLightColor"
            fontSize="small"
            lineHeight="1.5"
            marginBottom="large"
          >
            We will need you to upload a high-resolution logo that is 101px X 64px
            in a .jpeg format and has a background colour of your choice.
          </Text>

          <Text
            color="bodyFontLightColor"
            fontSize="small"
            lineHeight="1.5"
            marginBottom="large"
          >
            Please upload an image of the logo exactly the way you would like it
            to be displayed on the vendor facing page.
          </Text>
        </>
      )}

      { attachment_type === 'public_link_cover_image' && (
        <Text
          color="bodyFontLightColor"
          fontSize="small"
          lineHeight="1.5"
          marginBottom="large"
        >
          Cover image dimensions should be 1600x881px
        </Text>
      )}
    </>
  )
}

export default LogoText
